import { httpClient, ROOT_URL } from '../../App';
import { FormRule, message } from 'antd';
import { onlyLatinCharsDigitsSpecialSymbolsRule } from '../../utils/form.constants';

export const isSwiftAvailableApi = async (swift: string) => {
  return httpClient
    .get(`${ROOT_URL}/api/v1/banks/check-swift`, {
      params: { swift },
    })
    .then(res => {
      return res.data;
    })
    .catch(error => {
      message.error(`${error.response.status} ${error.response.statusText}`);
      return false;
    });
};

const bankNameLengthRules = [
  {
    min: 3,
    message: 'Minimum 3 characters',
    validateTrigger: 'onSubmit',
  },
  {
    max: 120,
    message: 'Maximum 120 characters',
    validateTrigger: 'onSubmit',
  },
];
export const bankNameRules = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: `Please enter bank name`,
    validateTrigger: 'onSubmit',
  },
  ...bankNameLengthRules,
];

export const intermediaryBankNameRules = [onlyLatinCharsDigitsSpecialSymbolsRule, ...bankNameLengthRules];

const bankSwiftLengthRules = [
  {
    min: 6,
    message: 'Minimum 6 characters',
    validateTrigger: 'onSubmit',
  },
  {
    max: 13,
    message: 'Maximum 13 characters',
    validateTrigger: 'onSubmit',
  },
];
export const bankSwiftRules = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: `Please enter bank swift`,
    validateTrigger: 'onSubmit',
  },
  ...bankSwiftLengthRules,
  {
    async validator(_: any, value?: string) {
      if (value && value.length >= 6 && value.length <= 13 && !/\s/.test(value)) {
        // const validationResult = await isSwiftAvailableApi(value);
        // if (validationResult) {
        //   return Promise.reject(validationResult);
        // } else {
        //   return Promise.resolve(true);
        // }
        return Promise.resolve(true);
      } else {
        return Promise.resolve(true);
      }
    },
    validateTrigger: 'onSubmit',
  },
];

export const intermediarySwiftRules = [onlyLatinCharsDigitsSpecialSymbolsRule, ...bankSwiftLengthRules];

const bankAddressLengthRules = [
  {
    min: 1,
    message: 'Minimum 1 characters',
    validateTrigger: 'onSubmit',
  },
  {
    max: 256,
    message: 'Maximum 256 characters',
    validateTrigger: 'onSubmit',
  },
];
export const bankAddressRules = [
  onlyLatinCharsDigitsSpecialSymbolsRule,
  {
    required: true,
    message: `Please enter bank address`,
    validateTrigger: 'onSubmit',
  },
  ...bankAddressLengthRules,
];

export const intermediaryAddressRules = [onlyLatinCharsDigitsSpecialSymbolsRule, ...bankAddressLengthRules];

export const intermediaryBankTelRules: FormRule[] = [
  {
    min: 6,
    message: 'Minimum 6 characters',
    validateTrigger: 'onSubmit',
  },
  {
    max: 21,
    message: 'Maximum 21 characters',
    validateTrigger: 'onSubmit',
  },
];
